import { Box, Typography } from '@mui/material'
import { merge } from 'lodash'
import { Inbox } from 'lucide-react'
import { isValidElement } from 'react'
import { animateProps } from '../utils/animateProps'

/**
 * Simple bolt + label content to show as an empty state for
 * various pages
 */
export const EmptyState = ({
  label,
  sx = {},
  icon,
  textVariant = 'textPrimary',
  color = 'text.secondary',
  iconProps = {},
  isFullPage,
  ...rest
}) => {
  return (
    <Box
      {...animateProps({
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1, transition: { duration: 0.25, ease: 'easeOut' } },
      })}
      sx={merge(
        {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: isFullPage ? '70vh' : '100%',
          color,
          gap: '10px',
        },
        sx
      )}
      {...rest}
    >
      {icon || <Inbox size={50} style={{ strokeWidth: 1, color: 'currentColor' }} {...iconProps} />}
      {isValidElement(label) ? label : <Typography variant={textVariant}>{label}</Typography>}
    </Box>
  )
}
